import { render, staticRenderFns } from "./xhmDetailv2.vue?vue&type=template&id=313d8d7c&"
import script from "./xhmDetailv2.vue?vue&type=script&lang=js&"
export * from "./xhmDetailv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports